jQuery(document).ready(function () {
    jQuery('.slick-slide-gallery').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        speed: 1000,
    });

    jQuery('#countrySelect').on('change', function () {
        if (this.value) {
            window.location.href = this.value;
        }
    });
});
